import React from 'react';
import { useTranslation } from 'react-i18next';
import { gender } from '../../../../../../enums/genderEnum';
import RowResumeText from '../../../../../../components/RowResumeText';
import { EMPTY_VALUES, getDateFormat, getFullName } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import { DocumentationFolderIcon, FolderPerson, IconBuildingTable } from '../../../../../../components/buttons/IconButtons';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryDetailsCard = ({ userData }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('details')}
            titleIcon={<DocumentationFolderIcon width={24} height={24} />}
            icon={<FolderPerson className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='grid-container-resume-data mb-2'>
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('name')}
                        value={getFullName(userData?.name, userData?.lastName, userData?.secondLastName) || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('documentId')}
                        value={userData?.documentId || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('email')}
                        value={userData?.email || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('mobile')}
                        value={userData?.phoneNumber ? '+' + userData?.phoneNumber : EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('gender')}
                        value={userData?.genderId ? t(gender[userData?.genderId]) : EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('dob')}
                        value={userData?.dob ? getDateFormat(userData?.dob, false) : EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('pin')}
                        value={userData?.pin || EMPTY_VALUES.DEFAULT}
                    />
                    <RowResumeText
                        className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                        title={t('password')}
                        Icon={IconBuildingTable}
                        value={userData?.password || EMPTY_VALUES.DEFAULT}
                    />
                </div>
            }
        />
    );
};

export default SummaryDetailsCard;
